import { channelSearchConstants } from '../constants';

const initialState = {
    sDate:{
      facebook:'',
      youtube:'',
    },
    eDate:{
      facebook:'',
      youtube:'',
    },
    viewData:[],
    commentData:[],
    subscribeData:[],
}

export function channelSearch(state = initialState, action) {
  switch (action.type) {
    case channelSearchConstants.GET_DAY:
      return{
        ...state,
        sDate:{...state.sDate,[action.channel]:action.sDate},
        eDate:{...state.eDate,[action.channel]:action.eDate}
      }
    case channelSearchConstants.RECEIVE_YT_DETAIL:
      return{
        ...state,
        subscribeData : action.viewData,
        viewData : action.commentData,
        commentData : action.subscribeData,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/channelSearch.reducer.js